export enum UserRole {
    PlatformAdmin = 'platform_admin',
    Admin         = 'admin',
    Staff         = 'staff',
}
